const {some,isEmpty} = lodash

export const AmzonImg = (({imageUrl, size ="", ext = "jpg", style, className, onClick} = props) =><img className={className} style={style? style: null} onClick={() => (onClick ? onClick() : null)} src={AmzonImgURL(imageUrl, size,ext)}></img>);
export const AmzonImgURL = (imageUrl, size ="", ext = "jpg") => {
	let lsize =	size? '._SL' + size +'_' : '';
	return imageUrl != 'NOIMG' && imageUrl != '#' && !isEmpty(imageUrl) ? 'https://m.media-amazon.com/images/I/' + imageUrl + lsize +'.' + (ext? ext : 'jpg'): 
										tfGlobal.homeUrl + '/wp-content/plugins/i2-azone/dist/images/no-image-available.png';
};
export const AmazonSelectImg = (images, idx = 0)=>{
	if (images && images != "#") {
		// console.log(JSON.parse(images));
		const obj = JSON.parse(images);
		if (obj && obj.length > idx) {
			return  obj[idx]['URL'];
		}
		return "NOIMG";
	}
}
export const AmazonSelectExt = (images, idx = 0)=>{
	if (images && images != "#") {
		// console.log(JSON.parse(images));
		const obj = JSON.parse(images);
		if (obj && obj.length > idx) {
			return  obj[idx]['EXT'];
		}
		return "jpg";
	}
}
export const MyBlockWrapper = (({isLink, id, href, style, className, onClick, children, target = "_blank", rel = "nofollow noopener noreferrer", elm = 'span'} = props) =>{
return (isLink ? <a id={id} href={href} style={style} className={className} onClick={onClick} target={target} rel={rel}>{children}</a> : 
	wp.element.createElement(elm, {id:id, style:style, className:className, onClick:onClick}, children))
})

//s?k=B00MNV8E0C
export const AmazonLink = (asin)=> tfGlobal.storeUrl + '/dp/'+ asin;
export const AmazonAffiliateLink = (asin)=> {
	return tfGlobal.add_proxy_link == '1' ? tfGlobal.homeUrl + '/' + tfGlobal.proxy_link_slug + '/' + asin :
	tfGlobal.storeUrl + '/dp/'+ asin + (tfGlobal.donotAddLink == '1' ? '' : '/?tag=' + tfGlobal.partnerTagForLink +'&linkCode=ogi&th=1&psc=1');
} 

export const AmazonSearchLink = (keyword)=> tfGlobal.storeUrl + '/s?k='+ keyword;
export const MySpace = (height = 15)=>{
	<div style={{height: height + "px", width: "100%", minWidth: "100%"}}></div>
}
export const ValidateASIN = (asin) => { return /^(B[\dA-Z]{9}|\d{9}(X|\d))$/.test(asin) };

export const SetDefaultColorPlate = (PreSetColors, obj)=>{
	if(obj !== undefined && some(PreSetColors, {color: obj}) !== true){
		let colors = [...PreSetColors];
		colors.push({name: 'Custom', color: obj});  
		return colors;             
	}
	return [...PreSetColors];          
 }

export const Log = (obj, obj2) => {
	console.log("======================");
	console.log(obj);
	if(typeof obj2 != undefined){
	console.log(obj2);
	}
	console.log("======================");
}

export const PrepareInlineStyle = ({color,bgColor, padding, border} = props)=>{
	let obj = {};
	//  obj.fontSize = fontSize + "px";
	//  obj.lineHeight = (fontSize * 2 ) + "px";
	//  console.log(border);
	  if(!isEmpty(color)){
		obj.color = color;
	  }
	  if(!isEmpty(bgColor)){
	    obj.backgroundColor = bgColor;
	  }
	  if(!isEmpty(padding)){
	    obj.padding = padding;
	  }
	  if(!isEmpty(border)){
	  if(border.useRadius == true && border.radius?.val > 0) {
		obj.borderRadius =  border.radius.val + border.radius.unit;
	  }
	  if(border.use == true && border.color != undefined){
		  obj.border = border.size.val + border.size.unit + " solid " + border.color; 
	  } else{
		  obj.borderColor = border.color;
	  }
	}
	//  console.log(obj);
	  return obj;
}

export const CleanText = (text) => {
//	console.log(text.replace(/\\/g,''))
	return text.replace(/\\/g,'');
}